export interface AlarmStatus {
    fetchAt?: Date;
    Coordinator_Info?: CoordinatorInfo[];
    Alarm: string;
    lastEvent: string;
    atDevice: string;
    tempMtrs?: TempMtr[];
    pwrMtrs?: PwrMtr[];
    VSupplies: VSupply[];
}

export interface CoordinatorInfo {
    name: string;
    a64: string;
    channel: string;
    panID: string;
    children: string;
}

export interface VSupply {
    V1: string;
    V2: string;
    V3: string;
}

export interface PwrMtr {
    a16: string;
    pwrDlvd: string;
}

export interface TempMtr {
    a16: string;
    tempC: string;
}

export function mapJsonToAlarmStatus(jsonString: string): AlarmStatus {
    const json = JSON.parse(jsonString);
    // Check if 'Ci' is present and is an array before mapping.
    const Coordinator_Info = Array.isArray(json.Ci) ? json.Ci.map((ci: any) => ({
        name: ci.name,
        a64: ci.a64,
        channel: ci.channel,
        panID: ci.panID,
        children: ci.children
    })) : undefined;

    // Check if 'Tm' is present and is an array before mapping.
    const tempMtrs = Array.isArray(json.Tm) ? json.Tm.map((tm: any) => ({
        a16: tm.A,
        tempC: tm.Tc
    })) : undefined;

    // Check if 'Pm' is present and is an array before mapping.
    const pwrMtrs = Array.isArray(json.Pm) ? json.Pm.map((pm: any) => ({
        a16: pm.A,
        pwrDlvd: pm.Pd
    })) : undefined;

    // Check if 'Vs' is present and is an array before mapping.
    const VSupplies = Array.isArray(json.Vs) ? json.Vs.map((vs: any) => ({
        V1: vs.V1,
        V2: vs.V2,
        V3: vs.V3
    })) : [];

    return {
        fetchAt: new Date(),
        Coordinator_Info: Coordinator_Info,
        Alarm: json.Al,
        lastEvent: json.Le,
        atDevice: json.Ad,
        tempMtrs: tempMtrs,
        pwrMtrs: pwrMtrs,
        VSupplies: VSupplies
    };
}



export interface ILocationFromDatabase {
    id: number;
    coreId: string;
    insertedDate: string;
    gpsTimestamp: string;
    longitude: number;
    latitude: number;
    valid: number;
}

export interface ILocationFromParticle {
    location: Location;
}

export interface Location {
    device_id: string;
    geometry: Geometry;
    sources: string[];
    horizontal_accuracy: number;
    product_id: number;
    last_heard: string;
    gps_lock: boolean;
    triggers: string[];
    timestamps: string[];
    properties: any[];
    device_name: string;
    groups: any[];
    online: boolean;
}

export interface Geometry {
    type: string;
    coordinates: number[];
}

//export interface IGeoLocation {
//    longitude: string;
//    latitude: string;
//    gpsTimestamp: Date;
//}
export interface IMiscInfo {
    Devices: string;
    GpsPositions: string;
    GpsLocus: string;
    Events: string;
    Orders: string;
    ResponsesAwaiting: string;
    Radius_GPS: string;
    RAM_Mem: string;
    EEPROM_Mem: string;
    Temperature: string;
}
export interface IStatusChange {
    device: string;
    status: string;
    age: string;
    atPosition: AtPosition[];
}
export interface ISensorAge {
    device: string;
    status: string;
    age: string;
    atPosition: AtPosition[];
}

export interface AtPosition {
    pos: string;
}
